import React from 'react';
import { FlexColumnBox } from 'styles/global';
import { Typography, useTheme } from '@mui/material';
import { ERROR_MESSAGES } from 'constants/error-messages';

export default function Unauthorized() {
  const theme = useTheme();
  return (
    <FlexColumnBox gap={2} minHeight="100vh">
      <Typography
        variant="h4"
        fontWeight="700"
        color={theme.palette.error.main}
      >
        Unauthorized
      </Typography>
      <Typography fontWeight="500" color={theme.palette.grey[600]}>
        {ERROR_MESSAGES.UNAUTHORIZED}
      </Typography>
    </FlexColumnBox>
  );
}
